import React from 'react';
import {
  Checkbox,
  Collapse,
  FormControlLabel,
  Paper,
} from '@mui/material';

interface CompanyFiltersProps {
  show: boolean;
  showOnlyActive: boolean;
  onShowOnlyActiveChange: (value: boolean) => void;
}

const CompanyFilters: React.FC<CompanyFiltersProps> = ({
  show,
  showOnlyActive,
  onShowOnlyActiveChange,
}) => {
  return (
    <Collapse in={show}>
      <Paper sx={{ p: 2, mb: 2, backgroundColor: 'background.default' }} variant="outlined">
        <FormControlLabel
          control={(
            <Checkbox
              checked={showOnlyActive}
              onChange={(e) => onShowOnlyActiveChange(e.target.checked)}
            />
          )}
          label="Показувати лише активні"
          sx={{ ml: 0 }}
        />
      </Paper>
    </Collapse>
  );
};

export default CompanyFilters;
